$(document).ready(function() {
    $.getScript("//cdnjs.cloudflare.com/ajax/libs/fancybox/2.1.5/jquery.fancybox.min.js").done(function() {
        quickView();
    });
});


function quickView() {
    $(document.body).on('click', '.quick-view', function() {

        if ($('#quick-view').length == 0) {
            $(document.body).append('<div id="quick-view"></div>');
        }
        var product_handle = $(this).data('handle');
        $('#quick-view').addClass(product_handle);
        jQuery.getJSON('/products/' + product_handle + '.js', function(product) {
            var title = product.title;
            var price = 0;
            var original_price = 0;
            var desc = product.description;
            var images = product.images;
            var variants = product.variants;
            var options = product.options;
            var url = '/products/' + product_handle;
            $('.qv-product-title').text(title);
            $('.qv-product-description').html(desc);
            $('.view-product').attr('href', url);

            var imageCount = $(images).length;
            $(images).each(function(i, image) {

                var image_embed = '<div><img src="' + image + '"></div>';
                image_embed = image_embed.replace('.jpg', '_400x.jpg').replace('.png', '_400x.png');
                $('.qv-product-images').append(image_embed);
            });
            $('.qv-product-images').slick({
                'dots': false,
                'arrows': true,
                'respondTo': 'min'

            }).css('opacity', '1');

            $(options).each(function(i, option) {
                var opt = option.name;
                var selectClass = '.option.' + opt.toLowerCase();
                $('.qv-product-options').append('<div class="option-selection-' + opt.toLowerCase() + '"><span class="option">' + opt + '</span><select class="field__input option-' + i + ' option ' + opt.toLowerCase() + '"></select></div>');
                $(option.values).each(function(i, value) {
                    $('.option.' + opt.toLowerCase()).append('<option value="' + value + '">' + value + '</option>');
                });
            });

            $(product.variants).each(function(i, v) {


                if (v.available == false) {
                    $('.qv-add-button').prop('disabled', true).val('Sold Out');
                    price = parseFloat(v.price / 100).toFixed(2);
                    original_price = parseFloat(v.compare_at_price / 100).toFixed(2);
                    $('.qv-product-price').text(price);
                    if (original_price > 0) {
                        $('.qv-product-original-price').text(original_price).show();
                    } else {
                        $('.original-price').hide();
                    }
                    return true
                } else {
                    $('.qv-add-button').prop('disabled', false).val('Add to Cart');
                    price = parseFloat(v.price / 100).toFixed(2);
                    original_price = parseFloat(v.compare_at_price / 100).toFixed(2);
                    $('.qv-product-price').text(price);
                    if (original_price > 0) {
                        $('.qv-product-original-price').text(original_price).show();
                    } else {
                        $('.original-price').hide();
                    }
                    $('select.option-0').val(v.option1);
                    $('select.option-1').val(v.option2);
                    $('select.option-2').val(v.option3);
                    return false
                }
            });
        });


        $(document).on("change", "#quick-view select", function() {
            var selectedOptions = '';
            $('#quick-view select').each(function(i) {
                if (selectedOptions == '') {
                    selectedOptions = $(this).val();
                } else {
                    selectedOptions = selectedOptions + ' / ' + $(this).val();
                }
            });
            jQuery.getJSON('/products/' + product_handle + '.js', function(product) {
                $(product.variants).each(function(i, v) {
                    if (v.title == selectedOptions) {
                        if (v.featured_image !== null) {
                            var iSlick = v.featured_image.position - 1;
                            $('.qv-product-images').slick('slickGoTo', iSlick);
                        }
                        var price = parseFloat(v.price / 100).toFixed(2);
                        var original_price = parseFloat(v.compare_at_price / 100).toFixed(2);
                        var v_qty = v.inventory_quantity;
                        var v_inv = v.inventory_management;


                        $('.qv-product-price').text(price);
                        $('.qv-product-original-price').text(original_price);

                        if (v.available == false) {
                            $('.qv-add-button').prop('disabled', true).val('Sold Out');
                        } else {
                            $('.qv-add-button').prop('disabled', false).val('Add to Cart');
                        }
                    }

                });


            });
        });
        $.fancybox({
            href: '#quick-view',
            maxWidth: 1000,
            maxHeight: 500,
            fitToView: true,
            width: '75%',
            height: '75%',
            autoSize: false,
            closeClick: false,
            openEffect: 'none',
            closeEffect: 'none',
            'beforeLoad': function() {
                var product_handle = $('#quick-view').attr('class');
                $(document).on("click", ".qv-add-button", function() {
                    var qty = $('.qv-quantity').val();
                    var v_title = '';
                    var selectedOptions = '';
                    var var_id = '';
                    $('#quick-view select').each(function(i) {
                        if (selectedOptions == '') {
                            selectedOptions = $(this).val();
                        } else {
                            selectedOptions = selectedOptions + ' / ' + $(this).val();
                        }
                    });
                    $.getJSON('/products/' + product_handle + '.js', function(product) {
                        $(product.variants).each(function(i, v) {
                            if (v.title == selectedOptions) {
                                var_id = v.id;
                                v_title = v.title;
                                $('.eqv_benbox').addClass("transparent");
                                processCart();
                            }
                        });
                    });

                    function processCart() {
                        $.post('/cart/add.js', {
                                quantity: qty,
                                id: var_id
                            }, null, "json")
                          
                            .done(function() {
                                $("#cart_reload").load("#cart_reload .cart_content > *",function () {
                                  $('.eqv_benbox').removeClass("transparent");
                                  $.fancybox.close();
                                  let s_popup = $("<div>").attr("class", "s_popup").html(`<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" t="1718590754310" class="icon" viewBox="0 0 1024 1024" version="1.1" p-id="4247" width="200" height="200"><path d="M514.048 59.392q93.184 0 174.592 35.328t142.336 96.768 96.256 143.36 35.328 175.104-35.328 175.616-96.256 143.872-142.336 96.768-174.592 35.328-175.104-35.328-142.848-96.768-96.256-143.872-35.328-175.616 35.328-175.104 96.256-143.36 142.848-96.768 175.104-35.328zM795.648 423.936q18.432-18.432 19.456-45.568t-17.408-45.568-45.056-17.92-45.056 18.944l-288.768 288.768-99.328-98.304q-18.432-18.432-45.056-18.944t-45.056 17.92-18.944 43.52 17.92 43.52l142.336 143.36q18.432 18.432 48.128 17.92t48.128-18.944l-4.096 4.096z" p-id="4248" fill="#36ab60"/></svg> 1 Item added to cart. `);
                                  $("body").append(s_popup);
                                  s_popup.css({
                                    'opacity': 0,
                                    'top': '44%'
                                  });
                                  s_popup.animate({
                                    'opacity': 1,
                                    'top': '49%'
                                  }, 200);
                                  setTimeout(function() {
                                    s_popup.animate({
                                      'opacity': 0,
                                      'top': '44%'
                                    }, 200, function() {
                                      s_popup.remove();
                                    });
                                  }, 2000);
                                  $(".cart-content").addClass('active');
                                  $(".overlay").addClass('overlay_active');
                                });
                                $('.qv-add-to-cart-response').addClass('success').html('<span>' + $('.qv-product-title').html() + ' <b>(' + v_title + ')</b> has been added to your cart. <a href="/cart">Click here </a>to view your cart.');
                                $(".cart-count-bubble").load(" .cart-count-bubble > *");
                            })

                            .fail(function($xhr) {
                                var data = $xhr.responseJSON;
                                $('.qv-add-to-cart-response').addClass('error').html('Data Description : ' + data.description);
                            });
                    }
                });
                $('.fancybox-wrap').css('overflow', 'hidden !important');
            },
            'afterShow': function() {
                $('#quick-view').hide().html(content).css('opacity', '1').fadeIn(function() {
                    $('.qv-product-images').addClass('loaded');
                });
            },
            'afterClose': function() {
                $('#quick-view').removeClass().empty();
            }
        });
    });
};

$(window).resize(function() {
    if ($('#quick-view').is(':visible')) {
        $('.qv-product-images').slick('setPosition');
    }
});